import header from './header.vue'
import footer from './footer.vue'
import lookimg from './lookimg.vue'
import scroll from './scroll.vue'
import search from './search.vue'
import calendarDate from './calendarDate.vue'
import tabsPane from './tabs-pane.vue'
import addimg from './addimg.vue'
import slideSelect from './slideSelect.vue'
import checkbox from './checkbox.vue'

export default {header, footer, lookimg, scroll, search, calendarDate, tabsPane, addimg, slideSelect, checkbox}



// WEBPACK FOOTER //
// ./src/components/index.js